// k - key, f - filename, h - height, w - width, m - mode (s - scale/c - crop / or a color), q - quality
export default ({ $config, isDev }, inject) => {
    const assetBase = 'https://assets.thiecommerce.com'
    const domainBase = $config.platform.mode

    const getImageUrl = (
        key,
        filename,
        width,
        height,
        quality = 70,
        mode = 'c',
        forceAssetBase = false
    ) => {
        const base = forceAssetBase || isDev ? assetBase : ''

        // bad data
        if (!key || !filename) return undefined

        // return original
        if (!width || !height) return `${base}/${domainBase}/${key}/${filename}`

        // return thumbed
        return `${base}/${domainBase}/${key}/r/${width}x${height}/${mode}/${quality}/${filename}`
    }

    const getAssetUrl = (filename, width, height, quality = 70, mode = 'c') => {
        const base = isDev ? assetBase : ''

        const fullPath = `${base}/assets/${$config.runtime.channelId}/static`

        // bad data
        if (!filename) return undefined

        // return original
        if (!width || !height) return `${fullPath}/${filename}`

        // return thumbed
        return `${fullPath}/r/${width}x${height}/${mode}/${quality}/${filename}`
    }

    const getImagePlaceholder = (width, height) => {
        return `data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}"/>`
    }

    inject('getImageUrl', getImageUrl)
    inject('getAssetUrl', getAssetUrl)
    inject('getImagePlaceholder', getImagePlaceholder)
}
